<template>
  <v-app v-touch="touchObj">

    <dx-scroll-view :height="isMobile ? 'auto' : '100vh'" direction="vertical">
      <v-parallax :src="systemCode ? `${baseUrl}static/bgimage/start_${systemCode}.png` : ''" height="auto" style="min-height: 100vh" class="root-parallax" :class="[backgroundImageVisible ? 'visible' : '']">

        <app-header v-if="isLogined && isNavVisible && !isSignFileView" :miniVariant="miniVariant" @toggleMenu="toggleDrawer"></app-header>

        <left-nav-panel v-if="!isSignFileView" v-model="leftNavPanelVisible" :miniVariant="miniVariant" :permanent="isLeftNavPanelPermanent" @onMiniVariantChanged="onMiniVariantChanged"></left-nav-panel>

        <v-main :class="[ isNativeIos ? 'pb-8' : '' ]">
          <dx-scroll-view ref="mainScrollView" @scroll="onMainContainerScrolled">
            <v-container fluid :class="mainContainerCssClass">

              <div v-if="(!isLogined || !isNavVisible) && testServerName && !isSignFileView" class="text-center text-body-1 error--text test-server-block">
                {{$t('header.testMode')}}&nbsp;{{testServerName}}
              </div>

              <router-view></router-view>

              <keep-alive>
                <router-view name="cached"></router-view>
              </keep-alive>

            </v-container>
          </dx-scroll-view>
        </v-main>

        <app-footer v-if="!isSignFileView"></app-footer>

      </v-parallax>
    </dx-scroll-view>

    <v-snackbar v-model="showMessage" :color="messageColor" :timeout="messageTimeOut" id="message-snackbar">
      <v-layout class="message-container overflow-hidden" column>
        <v-flex class="pb-2 overflow-hidden">
          <pre class="long-uninterrupted-text" style="overflow-wrap: anywhere" v-html="message"></pre>
        </v-flex>
        <v-flex class="text-right">
          <v-btn v-show="isLogined && messageId" dark text class="ma-0" @click="goToLogs(messageId)">
            {{$t('buttons.view')}}
          </v-btn>
          <v-btn dark text class="ml-4 ma-0" @click="showMessage = false">
            {{$t('buttons.close')}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-snackbar v-model="notification.show" :timeout="notification.timeout" :color="notification.color" dark right top class="notification-snackbar">
      <v-layout align-center>

        <v-flex shrink class="mx-3"><i class="far fa-envelope fa-lg"></i></v-flex>

        <v-flex @click="notificationClose">

          <router-link v-if="notification.type === NotificationType.UserGotDocument && !!notification.documentVersionCode" class="notif-link-module"
            :to="{name:'viewdoc',params:{moduleType:ModuleTypes.DocumentsIn,docverode:notification.documentVersionCode,folderId:0}}">
            {{$t('signalRNotifications.gotDocument')}}
          </router-link>
          <router-link v-else-if="notification.type === NotificationType.AuthorGotDecision && !!notification.documentVersionCode" class="notif-link-module"
            :to="{name:'viewdoc',params:{moduleType:ModuleTypes.DocumentsOut,docverode:notification.documentVersionCode,folderId:0}}">
            {{$t('signalRNotifications.gotDecision')}}
          </router-link>
          <router-link v-else-if="notification.type === NotificationType.DocumentGotNewComment && !!notification.documentVersionCode" class="notif-link-module"
            :to="{name:'viewdoc',params:{moduleType:ModuleTypes.DocumentsAll,docverode:notification.documentVersionCode,folderId:0}}">
            {{$t('signalRNotifications.gotComment')}}
          </router-link>
          <router-link v-else-if="notification.type === NotificationType.UserGotInvitation" :to="{name:RouterView.Invitations}" class="notif-link-module">
            {{$t('signalRNotifications.userGotInvitation')}}
          </router-link>
          <router-link v-else-if="notification.type === NotificationType.InvitationAuthorGotDecision" :to="{name:RouterView.OrgInvitations}"
            class="notif-link-module">
            {{$t('signalRNotifications.invitationAuthorGotDecision')}}
          </router-link>
          <router-link v-else-if="notification.type === NotificationType.UserDeletedFromOrganization" :to="{name:'notifications'}"
            class="notif-link-module">
            {{$t('signalRNotifications.userDeletedFromOrganization')}}
          </router-link>
          <router-link v-else-if="notification.type === NotificationType.UserCancelledDocumentSign && !!notification.documentVersionCode" class="notif-link-module"
            :to="{name:'viewdoc',params:{moduleType:ModuleTypes.DocumentsAll,docverode:notification.documentVersionCode,folderId:0}}">
            {{$t('signalRNotifications.userCancelledDocumentSign')}}
          </router-link>
          <div v-else>
            {{ notification.message }}
          </div>

        </v-flex>

        <v-flex shrink>
          <v-btn icon small class="ma-0" @click="notificationClose">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-flex>

      </v-layout>
    </v-snackbar>

    <v-snackbar v-model="clientVersionIsOutdated" color="#FED45F" :timeout="-1" top
      class="black--text font-weight-bold version-outdated-snack">
      <v-icon class="mr-2 black--text">fa-exclamation-triangle</v-icon>
      {{$t('app.clientVersionIsOutdated1')}}&nbsp;
      <a href="" click="router.go()">{{$t('app.clientVersionIsOutdated2')}}</a>&nbsp;
      {{$t('app.clientVersionIsOutdated3')}}
    </v-snackbar>

    <app-sign-dlg></app-sign-dlg>

    <app-idle-handler></app-idle-handler>

    <v-navigation-drawer v-if="!isNativeApp" v-model="showInstruction" app right temporary width="50vw" touchless>
      <v-container fluid class="py-2 px-0 fill-height">
        <div v-if="showInstructionFrameLoadProgress" class="app-instruction-frame-load-progress">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </div>
        <iframe ref="instructionFrame" v-if="frameRendered" :src="instructionUrl" class="app-instruction-frame" ></iframe>
      </v-container>
    </v-navigation-drawer>

    <app-checking-mobile-version></app-checking-mobile-version>

    <app-translation-warning v-if="isTranslationTrackerEnabled"></app-translation-warning>

    <app-promo-actions-user></app-promo-actions-user>

    <app-survey></app-survey>

    <v-fab-transition>
      <v-btn v-if="isScrollToTopBtnVisible" elevation="2" color="primary"
        fab fixed bottom right style="opacity: 0.5" @click="scrollToTop">
        <v-icon dark>fa-angle-up</v-icon>
      </v-btn>
    </v-fab-transition>

    <app-recaptcha></app-recaptcha>

    <v-tooltip :value="tooltip.show" :positionX="tooltip.x" :positionY="tooltip.y" top color="primary" :z-index="9999">
      {{ tooltip.message }}
    </v-tooltip>

  </v-app>
</template>

<script>
import cssVars from 'css-vars-ponyfill';

import get from 'lodash/get';
import debounce from 'lodash/debounce';
import * as MobDet from 'mobile-device-detect';

import AppHeader from '@/components/Main/AppHeader';
import LeftNavPanel from '@/components/Main/LeftNavPanel';
import AppFooter from '@/components/Main/AppFooter';
import AppSignDlg from '@/sign/components/AppSignDlg';
import AppIdleHandler from '@/components/Main/AppIdleHandler';
import AppCheckingMobileVersion from '@/components/Main/AppCheckingMobileVersion';
import AppTranslationWarning from '@/components/Main/AppTranslationWarning';
import AppPromoActionsUser from '@/components/Main/AppPromoActionsUser';
import AppSurvey from '@/components/Surveys/AppSurvey.vue';

import { eModuleTypes, NotificationType, Languages, RouterView } from '@/models/enums';
import { actions as _act } from '@/models/store.actions';
import { getLocale } from '@/helpers/locale-helper';
import { isNativeApp, isNativeIos } from '@/helpers/platform-helper';
import { isProduction, urlParam } from '@/helpers/utility';
import { isSignFileView } from '@/helpers/ui-helper';
import { setLoaderContext } from '@/mixins/ui-mixin';

import { DxScrollView } from 'devextreme-vue/scroll-view';
import { logger } from './helpers/log.service';
import AppRecaptcha from '@/components/Auth/AppRecaptcha.vue';
import routingMixin from '@/mixins/routing-mixin';

export default {
  name: 'App',
  components: {
    AppHeader,
    LeftNavPanel,
    AppFooter,
    AppSignDlg,
    DxScrollView,
    AppIdleHandler,
    AppCheckingMobileVersion,
    AppTranslationWarning,
    AppPromoActionsUser,
    AppRecaptcha,
    AppSurvey
  },
  mixins: [routingMixin],
  data() {
    return {
      leftNavPanelVisible: true,
      message: '',
      messageId: '',
      messageColor: 'accent',
      messageTimeOut: -1,
      miniVariant: false,
      notification: {
        documentVersionCode: '',
        show: false,
        type: 0,
        timeout: 20000,
        color: 'primary'
      },
      showMessage: false,
      systemCode: '',
      touchObj: {},
      isLeftNavPanelPermanent: true,
      showInstruction: false,
      instructionUrl: '',
      frameRendered: true,
      showInstructionFrameLoadProgress: false,
      isFooterVisible: true,
      isSignFileView: false,
      isTranslationTrackerEnabled: false,
      isScrollToTopBtnVisible: false,
      isAppScrollUsed: false,
      tooltip: {
        show: false,
        x: 0,
        y: 0,
        message: ''
      }
    };
  },
  provide() {
    return {
      isFirefox: MobDet.isFirefox,
      isIE: MobDet.isIE,
      isMobile: MobDet.isMobile,
      isMobileOnly: MobDet.isMobileOnly,
      isTablet: MobDet.isTablet,
      baseUrl: process.env.BASE_URL,
      isNativeApp: isNativeApp(),
      isSafari: MobDet.isSafari,
      getFooterVisibility: () => this.isFooterVisible
    };
  },
  created() {
    this.tryToSetSignFileMode();

    this.configureLeftNavPanel();

    window.addEventListener('keydown', this.onKeyDownGlobal);

    this.applyCustomTheme();

    this.addCssVarsIE();
  },
  mounted() {
    this.alertAboutCookies();
    this.setComponentsLocale();
    this.subscribe();
    setLoaderContext(this);
    this.tryLoadCounters();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    showNotification() {
      let ret = true;
      if (this.userNotifSettings) {
        ret = this.userNotifSettings.value ? /true/i.test(this.userNotifSettings.value) : /true/i.test(this.userNotifSettings.defaultValue);
      }
      return ret;
    },
    clientVersionIsOutdated() {
      return (
        isProduction() &&
        !!this.currentServerVersion &&
        !!this.currentVersion &&
        this.currentServerVersion !== this.currentVersion &&
        !isNativeApp()
      );
    },
    currentServerVersion() {
      return this.$store.getters[_act.SETT_GET_SERV_VERS];
    },
    currentVersion() {
      return this.$store.getters[_act.SETT_GET_CURENTVERSIONGET];
    },
    isIE() {
      return MobDet.isIE;
    },
    isLogined() {
      return this.$store.getters[_act.AUTH_GET_ISLOGINEDGET];
    },
    isMobileOnly() {
      return MobDet.isMobileOnly;
    },
    isMobile() {
      return MobDet.isMobile;
    },
    isNavVisible() {
      return ![
        RouterView.Login,
        RouterView.Registration,
        RouterView.RegistrationCompletion,
        RouterView.RestorePass,
        RouterView.RestorePassConfirm,
        RouterView.ConfirmEmail,
        RouterView.RegistrationConfirm,
        RouterView.AccountRestore,
        RouterView.ConfirmRestoreAccount,
        RouterView.ConfirmRemoveAccount,
        RouterView.ConfirmEmailUserOrg,
        RouterView.RoumingReg,
        RouterView.RoumingLogin
      ].includes(this.$route.name);
    },
    locale() {
      return this.$store.getters[_act.SETT_GET_LOCALEGET];
    },
    ModuleTypes() {
      return eModuleTypes;
    },
    NotificationType() {
      return NotificationType;
    },
    testServerName() {
      return this.appSettings ? this.appSettings.testServerName : '';
    },
    userNotifSettings() {
      return (this.userSettings || []).find(us => us.settingCode === 'clientNotif');
    },
    userSettings() {
      return this.$store.getters[_act.USETT_GET_USERSETTINGS];
    },
    isViewDoc() {
      return this.$route.name === 'viewdoc';
    },
    backgroundImageVisible() {
      return ['registration', 'login', 'contacts', 'supportRequest'].includes(this.$route.name) &&
        !this.isLogined;
    },
    baseUrl() {
      return process.env.BASE_URL;
    },
    isNativeIos() {
      return isNativeIos();
    },
    mainContainerCssClass() {
      let css = 'main-container';
      if (!this.isSignFileView) {
        if (this.isLogined && this.isNavVisible) {
          css = `${css} with-toolbar`;
        }
        if (this.isMobileOnly && !this.isViewDoc) {
          css = `${css} mobile`;
        }
        if (this.testServerName) {
          css = `${css} test-mode`;
        }
        if (this.isIE) {
          css = `${css} ie`;
        }
        if (this.isLogined && this.isNavVisible && this.leftNavPanelVisible) {
          css = `${css} nav-bar`;
        }
        if (this.miniVariant) {
          css = `${css} mini-variant`;
        }
        if (this.isFooterVisible) {
          css = `${css} with-footer`;
        }
      }

      if (this.isUnregUserView()) {
        css = `${css} unreg-user-view`;
      }

      return css;
    },
    isNativeApp() {
      return isNativeApp();
    },
    isDocumentsView() {
      return this.$route.name === 'docs';
    },
    RouterView() { return RouterView; }
  },
  methods: {
    notificationClose() {
      this.notification.show = false;
    },
    onKeyDownGlobal(e) {
      if (e.ctrlKey && e.keyCode === 66) {
        // crtl + B - toggle left nav panel
        e.preventDefault();
        e.stopPropagation();
        this.toggleDrawer();
      }
    },
    toggleDrawer() {
      if (!this.isLeftNavPanelPermanent) {
        this.leftNavPanelVisible = !this.leftNavPanelVisible;
      } else {
        this.miniVariant = !this.miniVariant;
      }
    },
    addCssVarsIE() {
      if (MobDet.isIE) {
        let theme;
        if (this.$vuetify.theme.isDark) {
          theme = get(this.$vuetify, 'theme.themes.dark');
        } else {
          theme = get(this.$vuetify, 'theme.themes.light');
        }
        if (theme) {
          cssVars({
            variables: {
              '--v-primary-base': theme.primary,
              '--v-secondary-base': theme.secondary,
              '--v-accent-base': theme.accent,
              '--v-error-base': theme.error,
              '--v-info-base': theme.info,
              '--v-success-base': theme.success,
              '--v-warning-base': theme.warning,
              '--v-app-colors-background-base': theme['app-colors-background'],
              '--v-app-colors-background-light-base': theme['app-colors-background-light'],
              '--v-app-colors-border-light-base': theme['app-colors-border-light'],
              '--v-app-colors-icon-default-base': theme['app-colors-icon-default'],
              '--v-app-colors-icon-inactive-base': theme['app-colors-icon-inactive'],
              '--v-app-colors-link-base': theme['app-colors-link'],
              '--v-app-colors-text-base': theme['app-colors-text'],
              '--v-telegram-color-base': theme['telegram-color'],
              '--v-viber-color-base': theme['viber-color']
            },
            watch: true
          });
        }
      }
    },
    async applyCustomTheme() {
      let appSettings = await this.$store.getters[_act.SETT_GET_STG_WAITER];
      let systemName = 'АСКОД Онлайн';
      let title = '';
      if (appSettings) {
        title = getLocale('common.apptitle');
        try {
          systemName = appSettings.globalSettings.globalSettingItems.sysnamelong.settingValue;
        } catch (_) {
        // ignored
        }
        title = title.replace('{SYSNAMELONG}', systemName);
      }
      document.title = title;

      this.systemCode = get(appSettings, 'systemName') || 'askod_online';
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      if (link) {
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = `${this.baseUrl}favicon_${this.systemCode}.ico`;
        if (document.getElementsByTagName('head').length > 0) {
          document.getElementsByTagName('head')[0].appendChild(link);
        }
      }
    },
    adjustMessageSnackPosition() {
      const snackEl = document.getElementById('message-snackbar');
      const heightDiff = snackEl.clientHeight - window.innerHeight;
      if (heightDiff > 0) {
        snackEl.style['padding-bottom'] = heightDiff + 12 /* default v-snack padding-bottom */ + 'px';
      }
    },
    onMiniVariantChanged(val) {
      this.miniVariant = val;
    },
    swipe(direction, e) {
      if (direction === 'right') {
        this.miniVariant = false;
      }
    },
    configureLeftNavPanel() {
      logger.info('[App:configureLeftNavPanel] mobile-device-detect:', MobDet);
      this.leftNavPanelVisible = this.isLeftNavPanelPermanent = !MobDet.isMobile;
      this.miniVariant = this.isLeftNavPanelPermanent && this.$vuetify.breakpoint.mdAndDown;

      if (this.isLeftNavPanelPermanent) {
        this.touchObj = {
          right: () => this.swipe('right')
        };
      }
    },
    goToLogs(messageId) {
      this.showMessage = false;
      if (messageId) {
        this.$router.push({ name: 'logs', params: { messageId } });
      }
    },
    subscribe() {
      this.$eventBus.$on('show-message', this.showMessageEventHandler);
      this.$eventBus.$on('document-notification', this.documentNotificationMesssageHandler);
      this.$eventBus.$on('show-tooltip', this.showTooltipEventHandler);
      this.$eventBus.$on('show-instruction', this.showInstructionHandler);
      this.$eventBus.$on('footer-visibility-changed', this.onFooterVisibilityChanged);
      this.$eventBus.$on('my-organization-changed', this.onSelectedMyOrganizationChanged);
      window.addEventListener('scroll', this.onAppScroll);
    },
    unsubscribe() {
      this.$eventBus.$off('show-message');
      this.$eventBus.$off('document-notification', this.documentNotificationMesssageHandler);
      this.$eventBus.$off('show-tooltip');
      window.removeEventListener('keydown', this.onKeyDownGlobal);
      this.$eventBus.$off('show-instruction', this.showInstructionHandler);
      this.$eventBus.$off('footer-visibility-changed', this.onFooterVisibilityChanged);
      this.$eventBus.$off('my-organization-changed', this.onSelectedMyOrganizationChanged);
      window.removeEventListener('scroll', this.onAppScroll);
    },
    setComponentsLocale() {
      this.$i18n.locale = this.locale;
      this.$vuetify.lang.current = this.locale;
    },
    tryLoadCounters() {
      if (this.isLogined) {
        this.$store.dispatch(_act.DOC_ACT_LOADCOUNTERS);
      }
    },
    documentNotificationMesssageHandler({ documentVersionCode, notificationType, message, timeout, color }) {
      this.notification.documentVersionCode = documentVersionCode;
      this.notification.type = notificationType;
      this.notification.message = message;
      this.notification.timeout = typeof timeout === 'undefined' ? 20000 : timeout;
      this.notification.color = typeof color === 'undefined' ? 'primary' : color;
      this.notification.show = this.showNotification;
    },
    showMessageEventHandler({ message, color, messageId, timeout, type }) {
      this.message = message;
      this.messageId = messageId;
      this.messageColor = color;
      this.messageTimeOut = timeout;
      this.showMessage = true;
      this.adjustMessageSnackPosition();
    },
    showTooltipEventHandler({ message, x, y, timeout }) {
      if (!message) return;
      const _timeout = typeof timeout === 'undefined' ? 2000 : timeout;
      this.tooltip.x = x;
      this.tooltip.y = y;
      this.tooltip.message = message;
      this.tooltip.show = true;
      setTimeout(() => {
        this.tooltip.show = false;
      }, _timeout);
    },
    alertAboutCookies() {
      if (!navigator.cookieEnabled) {
        this.showMessageEventHandler({
          message: getLocale('app.cookiesBlockedWarning'),
          color: 'warning',
          timeout: -1
        });
      }
    },
    showInstructionHandler({ instructionUrl }) {
      logger.debug('[App:showInstructionHandler]', instructionUrl);
      if (this.instructionUrl !== instructionUrl) {
        this.frameRendered = false;
        this.showInstructionFrameLoadProgress = !MobDet.isFirefox;
        this.$nextTick(() => {
          this.instructionUrl = instructionUrl;
          this.showInstruction = true;
          this.frameRendered = true;
          if (this.showInstructionFrameLoadProgress) {
            this.$nextTick(() => {
              this.$refs.instructionFrame.onload = () => {
                this.showInstructionFrameLoadProgress = false;
              };
            });
          }
        });
      } else {
        this.instructionUrl = instructionUrl;
        this.showInstruction = true;
      }
    },
    onFooterVisibilityChanged({ isFooterVisible }) {
      this.isFooterVisible = isFooterVisible;
    },
    tryToSetSignFileMode() {
      this.isSignFileView = isSignFileView();

      if (this.isSignFileView) {
        const newLocale = urlParam('locale');
        const allowedLanguages = Object.values(Languages);
        logger.info(`[App:tryToSetSignFileMode] newLocale=${newLocale} allowedLanguages=${allowedLanguages}`);
        if (newLocale &&
            allowedLanguages.some(l => l === newLocale) &&
            newLocale !== this.locale) {
          this.$store.commit(_act.SETT_MUT_LOCALESET, newLocale);
        }
      }
    },
    onSelectedMyOrganizationChanged() {
      if (!this.isDocumentsView) {
        this.tryLoadCounters();
      }
    },
    scrollToTop() {
      if (this.isAppScrollUsed) {
        window.scrollTo(0, 0);
      } else {
        this.$refs.mainScrollView.instance.scrollTo(0);
      }
    },
    onMainContainerScrolled: debounce(function(e) {
      this.isAppScrollUsed = false;
      this.isScrollToTopBtnVisible = e.scrollOffset.top > window.innerHeight;
    }, 500),
    onAppScroll: debounce(function(e) {
      this.isAppScrollUsed = true;
      this.isScrollToTopBtnVisible = window.scrollY > window.innerHeight;
    }, 500)
  }
};
</script>

<style lang="scss">
@import '~lato-font/css/lato-font.css';
@import '@/styles/variables.scss';

.v-application {
  font-family: Lato;
}

#message-snackbar {
  .v-snack__content {
    padding-bottom: 0.5em;
  }
  .message-container {
    max-height: 30vh;
    pre {
      white-space: pre-wrap;
    }
  }
}
.v-snack.notification-snackbar {
  padding-top: 5em;
  .v-snack__wrapper {
    background-color: var(--v-app-colors-background-light-base);
    border: 1px solid var(--v-primary-base);
    border-radius: $app-defaults-border-radius;
    opacity: 0.9;
    border-radius: 8px;
    .v-snack__content {
      padding: 0.5em;
      a.notif-link-module,
      i:not(.fa-times) {
        color: var(--v-app-colors-background-light-base);
      }
    }
  }
}
.v-snack.version-outdated-snack {
  .v-snack__content {
    height: auto;
    padding: 0.5em 1em;
  }
}
.v-parallax.root-parallax {
  .v-parallax__content {
    padding: 0;
    color: inherit;
  }
  .v-parallax__image-container {
    opacity: 0;
  }
  &.visible .v-parallax__image-container {
    opacity: 0.15;
  }
}
.app-instruction-frame {
  width: 100%;
  height: 100%;
  border: none;
}
.app-instruction-frame-load-progress {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
